module.exports = __webpack_public_path__ + "img/installation.564dc949.svg";